import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: 'https://cyanjeddah.com',
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
})

// Request interceptor
axiosInstance.interceptors.request.use(
    config => {
        // You can add authorization headers here
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// Response interceptor
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        // Handle errors here
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // Handle unauthorized
                    break
                case 404:
                    // Handle not found
                    break
                default:
                    // Handle other errors
                    break
            }
        }
        return Promise.reject(error)
    }
)

export default axiosInstance